module.exports = __webpack_public_path__ + "static/media/ardilla.18e483b9.png";